export default {
    "title": "🇨🇳 中文简体",

    "很棒的住宿体验": "很棒的住宿体验",
    "清爽干净，维护良好": "清爽干净，维护良好",
    "很棒的餐厅和员工": "很棒的餐厅和员工",
    "价值符合预期": "价值符合预期",
    "卓越的": "卓越的",

    "首页": "首页",
    "资讯": "资讯",
    "预订": "预订",
    "订单": "订单",
    "关于": "关于",
    "发现": "发现",
    "会员": "会员",
    "推荐计划": "推荐计划",
    "我的": "我的",
    "个人": "个人",
    "推荐": "推荐",
    "事件": "事件",
    "登出": "登出",
    "登录": "登录",
    "注册": "注册",
    "语言": "语言",
    "忘记密码": "忘记密码",
    "取消": "取消",
    "确认": "确认",
    "酒店": "酒店",
    "银行卡列表": "银行卡列表",
    "银行列表": "银行列表",
    "持卡人姓名": "持卡人姓名",
    "银行卡号": "银行卡号",
    "支付密码": "支付密码",
    "提交": "提交",
    "Pix列表": "Pix列表",
    "Pix类型": "Pix类型",
    "Pix账号": "Pix账号",
    "账号列表": "账号列表",
    "网络": "网络",
    "地址": "地址",
    "备注": "备注",
    "充值金额": "充值金额",
    "支付类型": "支付类型",
    "支付银行": "支付银行",
    "USDT地址": "USDT地址",
    "二维码": "二维码",
    "充值渠道": "充值渠道",
    "充值凭证": "充值凭证",
    "立即登录": "立即登录",
    "用户名": "用户名",
    "密码": "密码",
    "邀请码": "邀请码",
    "确认密码": "确认密码",
    "手机": "手机",
    "金额": "金额",
    "新增": "新增",
    "钱包余额": "账户余额",
    "单价": "单价",
    "数量": "数量",
    "总额": "总额",
    "奖励": "奖励",
    "手机号码": "手机号码",
    "修改密码": "修改密码",
    "登录密码": "登录密码",
    "当前密码": "当前密码",
    "新密码": "新密码",
    "确认新密码": "确认新密码",
    "保存修改": "保存修改",
    "充值": "充值",
    "复制": "复制",
    "邀请链接": "邀请链接",
    "复制链接": "复制链接",
    "升级": "升级",
    "登录时间": "登录时间",
    "信誉分": "信誉分",
    "提现": "提现",
    "提现账号": "提现账号",
    "你确定要删除此账号吗": "你确定要删除此账号吗",
    "你确定要删除此地址吗": "你确定要删除此地址吗",
    "提示": "提示",
    "是": "是",
    "否": "否",
    "全部": "全部",
    "待处理": "待处理",
    "冻结中": "冻结中",
    "已完成": "已完成",
    "关于我们": "关于我们",
    "创建时间": "创建时间",
    "你确定要登出当前账号吗？": "你确定要登出当前账号吗？",
    "正在寻找餐厅": "正在寻找餐厅",
    "旅程价格": "旅程价格",
    "佣金": "佣金",
    "搜索": "搜索",
    "评分": "评分",
    "评论": "评论",
    "评论2": "评论",
    "你还没有设置支付密码，请前往设置": "你还没有设置支付密码，请前往设置",
    "请输入": "请输入",
    "请选择": "请选择",
    "账户明细": "账户明细",
    "等级": "等级",
    "每日订单": "每日订单",
    "设置": "设置",
    "语言设置": "语言设置",
    "客服": "客服",
    "专属客户服务": "专属客户服务",
    "帮助": "帮助",
    "复制成功": "复制成功",
    "你好": "你好",
    "我的账户": "我的账户",
    "头像": "头像",
    "昵称": "昵称",
    "设置昵称": "设置昵称",
    "订单时间": "订单时间",
    "产品": "产品",
    "订单数量": "订单数量",
    "提交订单": "提交订单",
    "可用余额": "可用余额",
    "总金额": "总金额",
    "冻结金额": "冻结金额",
    "佣金比例": "佣金比例",
    "获得佣金": "获得佣金",
    "完成订单": "完成订单",
    "请至少选择一项": "请至少选择一项",
    "请先选择星星": "请先选择星星",
    "公告": "公告",
    "邀请好友": "邀请好友",
    "邀请好友赚取佣金": "邀请好友赚取佣金",
    "条款&协议": "条款&协议",
    "注册协议": "注册协议",
    "我已阅读并同意": "我已阅读并同意",
    "还有没有账号？": "还有没有账号？",
    "已有没有账号？": "已有没有账号？",
    "去注册": "去注册",
    "去登录": "去登录",
    "佣金排行榜": "佣金排行榜",
    "新团队成员": "新团队成员",
    "会员等级": "会员等级",
    "当前等级": "当前等级",
    "国际知名餐厅": "国际知名餐厅",
    "最受欢迎的餐厅": "最受欢迎的餐厅",
    "精选餐厅": "精选餐厅",
    "餐厅推广": "餐厅推广",
    "欢迎来到": "欢迎来到",
    "体验最好的服务": "体验最好的服务",
    "一键推广": "一键推广",
    "预订说明": "预订说明",
    "预订说明-tips-1": "1、一键押金，平等等待系统完成分配，分配确认成功后确认，即刻完成各项餐厅押金工作。",
    "预订说明-tips-2": "2、当您被分配到豪华餐厅时，您将无法完成客户餐厅的预订，在等待页面尚未完成。",
    "预订说明-tips-3": "3、餐厅所拥有的豪华餐厅专用税金对公众开放，无法办理、人为变更、取消、撤回或跳过。",
    "预订说明-tips-4": "注：如需上前一步，请在线联系客服。",
    "订单记录": "订单记录",
    "预期收益": "预期收益",
    "餐厅名称": "餐厅名称",
    "匹配优质餐厅中": "匹配优质餐厅中",
    "等待餐厅确认": "等待餐厅确认",
    "餐厅巳确认": "餐厅巳确认",
    "您当前等级是": "您当前等级是",
    "升级会员可获得更多特权": "升级会员可获得更多特权",
    "查看": "查看",
    "常用工具": "常用工具",
    "加载中...": "加载中...",
    "没有更多数据": "没有更多数据",
    "home_tips_1": `欢迎来到Eat-Marketing，一个专业的餐厅和食品服务营销平台。`,
    "home_tips_2": `我们提供一个便捷的在线系统，将用户与餐厅推广和餐饮推广服务连接起来。我们的平台旨在帮助餐厅提高知名度，改善客户参与度，并增强整体品牌曝光度。`,
    "home_tips_3": `通过我们的结构化推广计划，用户可以参与精选的餐厅营销活动，支持餐饮企业扩大影响力，吸引更多客户。`,
    "home_tips_4": `Eat-Marketing致力于为餐厅和平台参与者提供一个透明、高效、可靠的数字环境。`,
    // "aaa": "vvv",
    // "aaa": "vvv",
    // "aaa": "vvv",
}